export class Usuario {
    constructor(
        public nome: string,
        public user: string,
        public senha: string,
        public email: string,
        public tipoPermissao: string

    ){}
}